<template>
  <div class="document-creator">
    <popup-modal
      :top="popupStyle.top"
      v-model="showPop"
      :isCustomClose="true"
      @customClose="close"
      z-index="101"
      :body-style="popupStyle"
      use-height-change-transition
      class="document-creator"
    >
      <div class="modal-list-wrapper" :style="transformStyle">
        <div class="pre-select modal-wrapper" v-if="_hasPreSelect || needPreSelect">
          <quickly-creator
            v-if="createEnters.length > 0"
            :createEnters="createEnters"
            :historyList="historyListV2"
            @quicklyCreate="quicklyCreate"
            @selectCreateType="selectCreateType"
          >
          </quickly-creator>
          <div></div>
          <div class="popup-footer">
            <img class="close-img" @click.stop="close" v-click-feedback :src="images.closeV3" />
          </div>
        </div>

        <div
          class="modal-wrapper"
          v-for="(model, index) in operationArray"
          :key="model.mode"
          :class="{ 'border-right': index < operationArray.length - 1 }"
        >
          <div v-if="!isSearchingMode" class="select-model">
            <div class="popup-header">
              <div class="left-arrow">
                <div class="go-back" v-if="index > 0 || _hasPreSelect || needPreSelect">
                  <span class="go-back-span" v-click-feedback="'deep-background'" @click="goBack()">
                    <img class="go-back-img" :src="images.back" />
                  </span>
                </div>
              </div>
              <div class="title">
                <div>{{ model.title }}</div>
                <div class="sub-title" v-if="model.subTitle">{{ model.subTitle }}</div>
              </div>
              <div class="right-arrow" @click="search(model.forbidSearching)">
                <img class="right-arrow-img" v-if="!model.forbidSearching" :src="images.search" />
              </div>
            </div>
            <div class="popup-content" :class="{ 'has-expense-item': quickCreateExpenseClaim }">
              <div v-if="!model.categoryList">
                <div
                  class="default-jobs"
                  v-if="currentUserSelectJob && model.mode === 'document' && !quickCreateExpenseClaim"
                  @click="changeJobs()"
                >
                  <div class="jobs">
                    <div class="position">
                      {{ (!isSelf ? currentApplicant.fullName + ' | ' : '') + currentUserSelectJob.mainText }}
                    </div>
                    <div class="default-text" v-if="currentUserSelectJob.docDefault">
                      {{ $t('global-1.key155', { cm: '默认' }) }}
                    </div>
                  </div>
                  <div class="company">
                    {{ currSelectJob }}
                  </div>
                  <div class="change-job">
                    {{ $t('global-1.key156', { cm: '更改' }) }}
                  </div>
                </div>
                <div
                  class="recommend-document"
                  v-if="quickCreateExpenseClaim && recomDocumentList.length && currentMode === 'document'"
                >
                  <div class="document-title">{{ $t('global-1.key279', { cm: '复制历史单据快速创建' }) }}</div>
                  <div
                    class="recommend-item"
                    :class="{ 'not-last': index + 1 !== recomDocumentList.length }"
                    v-for="(item, index) in recomDocumentList"
                    :key="item.expenseReportOID"
                    v-click-feedback="'deep-background'"
                    @click="doSelect(model.operationMethod, item)"
                  >
                    <div>
                      <span class="formName text-ellipsis">{{ item.formName }}</span>
                      <span class="createDate">{{ format(item.createdDate, 'date') }}</span>
                    </div>
                    <div class="mark-and-amount">
                      <span class="title text-ellipsis"
                        >{{ $t('global-1.key258', { cm: '事由：' }) }}{{ item.title }}</span
                      >
                      <div class="amount-wrap">
                        <span class="amount">{{ `${item.currencyCode} ${format(item.totalAmount, 'amount')}` }}</span>
                        <span class="amount" v-if="formType === '106' && isNumber(item.paymentAmount)">{{
                          `${item.currencyCode} ${format(item.paymentAmount, 'amount')}`
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="document-title" v-if="quickCreateExpenseClaim && currentMode === 'document'">
                  {{ $t('global-1.key280', { cm: '直接创建新单据' }) }}
                </div>
                <div
                  class="list-item"
                  :class="{ 'has-voice-input': voiceInput && item.formType == '2001' && model.mode === 'document' }"
                  @click="doSelect(model.operationMethod, item)"
                  v-click-feedback="'deep-background'"
                  v-for="(item, index) in model.operationList"
                  :key="index"
                >
                  <div class="list-row">{{ item[model.showKey] }}</div>
                  <div v-if="model.extraShowKey" class="list-row extra-text">{{ item[model.extraShowKey] }}</div>
                  <span
                    class="img-wrapper voice-wrapper"
                    v-if="voiceInput && item.formType == '2001' && model.mode === 'document'"
                    v-click-feedback="'deep-background'"
                    @click.stop.prev="onVoiceClick(item)"
                  >
                    <img :src="images.btnMicrophone" alt="" class="img-responsive" />
                  </span>
                </div>
                <empty-content
                  v-if="model.mode === 'document' && model.operationList && !model.operationList.length && !loadingFlag"
                  :imgStyle="emptyImgStyle"
                  type="emptyFolder"
                />
              </div>
              <div class="category-list" v-if="model.categoryList">
                <div class="category-item" v-for="category in model.categoryList">
                  <div class="category-name">
                    {{ category.name }}
                  </div>
                  <div
                    class="list-item"
                    :class="{ 'has-voice-input': voiceInput && item.formType == '2001' && model.mode === 'document' }"
                    v-click-feedback="'deep-background'"
                    v-for="(item, index) in category.list"
                    :key="index"
                  >
                    <div class="list-item-inner" @click="doSelect(model.operationMethod, item)">
                      <div class="list-item-inner2" :class="{ 'show-default': isSelf }">
                        <div class="list-row">{{ item[model.showKey] }}</div>
                        <div v-if="model.extraShowKey" class="list-row extra-text">
                          {{ hasExtrashow(item, model.extraShowKey) }}
                        </div>
                        <span
                          class="img-wrapper voice-wrapper"
                          v-if="voiceInput && item.formType == '2001' && model.mode === 'document'"
                          v-click-feedback="'deep-background'"
                          @click.stop.prev="onVoiceClick(item)"
                        >
                          <img :src="images.btnMicrophone" alt="" class="img-responsive" />
                        </span>
                      </div>
                    </div>
                    <div class="default-job" v-if="isSelf" @click="doDefaultJob(item, model, $event)">
                      <div class="default-job-inner">
                        <svg-icon type="un-check" v-if="!item.docDefault" class="unselect-all-image check-img" />
                        <svg-icon type="checkbox" v-if="item.docDefault" class="select-all-image check-img" />
                        <div class="text">{{ $t('global-1.key155', { cm: '默认' }) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="popup-footer">
              <img class="close-img" v-click-feedback @click.stop="close" :src="images.closeV3" />
            </div>
          </div>
          <div v-else class="search-model">
            <div class="popup-header-search">
              <div class="base-search-head ignore-rem">
                <div class="base-search-body ignore-rem" @click="focusInput">
                  <img :src="images.search" class="search-icon" />
                  <input
                    type="text"
                    :ref="'input' + model.mode"
                    class="search-input-area"
                    v-model="keyword"
                    :placeholder="model.searchPlaceholder"
                  />
                  <img
                    :src="images.clearSearchImg"
                    v-if="keyword !== ''"
                    @click="clearKeyword"
                    class="clear-search-icon"
                  />
                </div>
                <div
                  class="cancel-search-button ignore-rem"
                  v-click-feedback="'weak-filter'"
                  @click.stop="closeSearch()"
                >
                  {{ $t('common.key7', { cm: '取消' }) }}
                </div>
              </div>
            </div>
            <div class="popup-content-search" v-if="searchResult.length">
              <template v-if="model.mode === 'job'">
                <multi-job :jobList="searchResult" :model="model" @multiJobEvent="multiJobEvent"> </multi-job>
              </template>
              <template v-else>
                <div v-if="!model.categoryList">
                  <div
                    v-for="item in searchResult"
                    class="list-item"
                    v-click-feedback="'deep-background'"
                    @click="doSelect(model.operationMethod, item)"
                  >
                    <div class="list-row">{{ item[model.showKey] }}</div>
                    <div v-if="model.extraShowKey" class="list-row extra-text">{{ item[model.extraShowKey] }}</div>
                  </div>
                </div>

                <div v-if="model.categoryList">
                  <div class="category-item" v-for="category in searchResult">
                    <div class="category-name">
                      {{ category.name }}
                    </div>
                    <div
                      class="list-item"
                      v-click-feedback="'deep-background'"
                      @click="doSelect(model.operationMethod, item)"
                      v-for="(item, index) in category.list"
                      :key="index"
                    >
                      <div class="list-row">{{ item[model.showKey] }}</div>
                      <div v-if="model.extraShowKey" class="list-row extra-text">{{ item[model.extraShowKey] }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <empty-content v-if="!searchResult.length && keyword" type="nonSearchResult" />
          </div>
        </div>
      </div>
    </popup-modal>

    <popup-modal
      :top="popupStyle.top"
      v-model="showProxy"
      :isCustomClose="true"
      @customClose="close"
      z-index="101"
      :body-style="popupStyle"
      use-height-change-transition
      class="document-creator"
    >
      <div>
        <div class="popup-header">
          <div class="left-arrow">
            <div class="go-back">
              <span class="go-back-span" v-click-feedback="'deep-background'" @click="goBack()">
                <img class="go-back-img" :src="images.back" />
              </span>
            </div>
          </div>
          <div class="title">
            <div>{{ $t('global-1.key307', { cm: '选择申请人' }) }}</div>
          </div>
          <div class="right-arrow">
            <img class="right-arrow-img" :src="images.search" />
          </div>
        </div>
        <div>
          <div>{{ getMyInfo && getMyInfo.fullName }}</div>
          <div>{{ $t('global-1.key308', { cm: '代理他人' }) }}</div>
          <div>{{ $t('global-1.key309', { cm: '小贴士：给他人创建单据，比如：秘书给老板提单据' }) }}</div>
        </div>
      </div>
    </popup-modal>
  </div>
</template>
<script>
// 组件
import EmptyContent from 'components/base-ui/empty-content';
import PubListItem from 'components/base-ui/pub-list-item';
import HlyScroll from 'components/business/hly-scroll';
import Loading from 'components/base-ui/loading';
import PopupModal from 'components/base-ui/popup-modal';
import QuicklyCreator from 'components/business/common/document-creator/quick-creator/index';
import MultiJob from './multi-job';

// 图片
import backBlueImg from 'assets/images/application/subsidies-detail/back-blue@3x.png';
import searchImg from 'assets/images/common/search@3x.png';
import clearSearchImg from 'assets/images/common/clear-btn@2x.png';
import closeImg from 'assets/images/common/close-v2@2x.png';

import closeV3 from 'assets/images/common/close-v3.png';
import back from 'assets/images/common/back.png';
import search from 'assets/images/common/search.png';
import unChecked from 'assets/images/common/rounded-checkbox-blank@3x.png';
import checked from 'assets/images/common/rounded-checkbox@3x.png';

import createErImg from 'assets/images/refactor-main/create-er@3x.png';
import createAppImg from 'assets/images/refactor-main/create-app@3x.png';
import createExpenseImg from 'assets/images/refactor-main/create-expense@3x.png';
import createLoanBillImg from 'assets/images/refactor-main/create-loanbill@3x.png';
import btnMicrophone from 'assets/images/application/voice/btn-microphone@3x.png';

// api
import { changeProtocolStatus, getFastCreate } from 'api/main/index';
import { getCreateHistory, getCreateHistoryV2 } from 'api/main/index';
import corpPaymentServices from 'api/corp-payment';
import ExpenseReportService from '@/api/expense-report';
import ApplicationHandler from 'service/application/index';

import { defaultUserJobId } from 'api/common-document';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { forbidScrollMixin, methodsMixin } from 'service/vue-mixin';
import debounce from 'lodash.debounce';
import scanService from 'service/scanHandle';
import eventService from '@/service/native/eventTrackService';
import corEventService from 'views/corporate-documents/utils/event.service';
import moment from 'moment';
import commonQuickCreatorHandler from 'components/business/common/document-creator/index.handler';
import { pinYinMatch } from 'src/sub-tree/common/src/base/utils';
import { customDepartmentName } from 'service/job';

export default {
  name: 'document-creator',
  mixins: [forbidScrollMixin, methodsMixin],
  /**
   * formType 表单类型，不传则需要选择表单类型，参考首页加号 101申请单 102报销单 104借款单 105付款申请单 111我的供应商 114预提单
   * value 使用v-model绑定
   *
   * @input 修改value
   * @go-voice-record 语音功能，与原来一致
   * @will-create-document 监听此事件可用于记录何时发生表单创建，不用这个事件来做路由跳转
   */
  props: {
    formType: {
      type: String,
    },
    value: {
      type: Boolean,
      default: false,
    },
    onlyJob: {
      type: Boolean,
      default: false,
    },
    skipProxy: {
      type: Boolean,
      default: false,
    },
    isExpense: {
      // 后续可调整 针对与账本 新建报销单 子应用跳转处理（目前是标识从账本进来的）
      type: Boolean,
      default: false,
    },
    quickCreateExpenseClaim: {
      type: Boolean,
      default: false,
    },
    invoiceOIDs: {
      type: String,
      default: '',
    },
    createDateList: {
      type: Array,
    },
    copyDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    copy: {
      type: Boolean,
      default: false,
    },
    // 表单之间快速创建 需要携带其他单据相关的信息 不太好的设计 目前就先这样 加个字段标识携带的数据 后续看有没有更好的整理方案
    contractLineInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    // 表单接业务参数 防止后续传入的业务参数过多
    businessParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      images: {
        btnMicrophone,
        backBlueImg,
        searchImg,
        clearSearchImg,
        closeImg,
        unChecked,
        checked,
        closeV3,
        back,
        search,
      },
      isSearchingMode: false,
      currentValue: false,
      keyword: '', //模糊查询字段
      searchResult: [], // 搜索结果
      historyList: [],
      historyListV2: [],
      applicantsList: [],
      jobsList: [],
      documentsList: [],
      currentApplicant: {},
      currentDocument: {},
      currentJob: {},
      // closingSearch: false,   // 用于确保搜索框收起时有动画,
      fastCreateDisable: {
        application: true,
        expenseReport: true,
        expense: true,
        loanBill: true,
        contract: true,
        businessPayment: true,
        apRequest: true,
      },
      enableProtocol: {
        application: true,
        expenseReport: true,
        expense: true,
        loanBill: true,
        contract: true,
        businessPayment: true,
        apRequest: true,
      },
      protocol: {
        application: null,
        expenseReport: null,
        expense: null,
        loanBill: null,
        contract: null,
        businessPayment: null,
        apRequest: null,
      },
      userProtocol: {
        application: null,
        expenseReport: null,
        expense: null,
        loanBill: null,
        contract: null,
        businessPayment: null,
        apRequest: null,
      },
      protocolStatus: {},
      clientWidth: undefined,
      currentFormType: '',
      currentMode: '',
      hasProxyAuth: false,
      hasMultiJobs: false,
      skipJobs: false,
      currentUserSelectJob: null,
      emptyImgStyle: {
        width: '64px',
        height: '64px',
      },
      recomDocumentList: [], // 推荐单据
      loadingFlag: false, // 单据加载状态 单据加载时回显示空页面
      showProxy: false,
    };
  },
  computed: {
    ...mapState(['proxyData']),
    ...mapGetters(['getProfile', 'isInApp', 'getMyInfo', 'getUserInfo', 'getUserToken', 'getTenantProfile']),
    showPop: {
      get: function () {
        if (this.isExpense && !this.quickCreateExpenseClaim) {
          return this.currentValue && !!this.currentMode;
        }
        return this.currentValue;
      },
      set: function (newValue) {
        this.currentValue = newValue;
      },
    },
    //业务页面当前选人的岗位
    currSelectJob() {
      let seljob = this.currentUserSelectJob;
      return (
        customDepartmentName(seljob.departmentName, seljob.departmentPath, '-') +
        '-' +
        seljob.companyName +
        (seljob.duty ? '-' + seljob.duty : '') +
        (seljob.rank ? '-' + seljob.rank : '')
      );
    },
    _hasPreSelect() {
      return !this.formType && !this.onlyJob;
    },
    isCorpBusiness() {
      return this.formType === '106' && !this.isExpense;
    },
    _modeArray() {
      let { hasProxyAuth, hasMultiJobs, skipJobs, _hasPreSelect, needPreSelect } = this,
        res = [];
      if (_hasPreSelect || needPreSelect) {
        res.push('pre');
      }
      if (hasProxyAuth) {
        res.push('applicant');
      }
      if (hasMultiJobs && !skipJobs) {
        res.push('job');
      }
      res.push('document');

      if (hasMultiJobs && skipJobs) {
        res.push('job');
      }

      return res;
    },
    _modeIndex() {
      let { currentMode, _modeArray } = this;
      let index = _modeArray.indexOf(currentMode);
      return index === -1 ? 0 : index;
    },
    _formType() {
      let { formType, currentFormType } = this;
      return currentFormType || formType;
    },
    voiceInput() {
      return this.getProfile['app.voice.input.form.enabled'] && this._formType === '101' && this.isInApp;
    },
    // 当前搜索列表
    searchTargetList() {
      let { currentMode } = this;
      switch (currentMode) {
        case 'applicant':
          return this.applicantsList;
        case 'job':
          return this.jobsList;
        case 'document':
          return this.documentsList;
        case 'default':
          return [];
      }
    },
    popupStyle() {
      let searching = this.isSearchingMode;
      let style = {
        borderTopRightRadius: '5px',
        borderTopLeftRadius: '5px',
        overflow: 'hidden',
        bottom: '0',
        top: '40%',
      };
      searching && (style.top = '0.3rem');
      return style;
    },
    modelArray() {
      return [
        {
          mode: 'applicant',
          title: window.$t('global-1.key157', { cm: '请选择申请人' }),
          operationList: this.applicantsList,
          showKey: 'fullName',
          operationMethod: 'selectApplicant',
          searchPlaceholder: window.$t('global-1.key158', { cm: '按申请人姓名／工号查询' }),
        },
        {
          mode: 'job',
          title: window.$t('global-1.key159', { cm: '请选择岗位' }),
          categoryList: this.jobsList,
          showKey: 'mainText',
          extraShowKey: ['extraText', 'duty', 'rank'],
          operationMethod: 'selectJob',
          searchPlaceholder: window.$t('global-1.key281', { cm: '职位 公司名称 部门名称 职务名称 级别名称' }),
          forbidSearching: false,
        },
        {
          mode: 'document',
          title: window.$t('global-1.key161', { cm: '请选择单据' }),
          subTitle:
            this.formType === '102' && !this.isExpense && window.$t('global-1.key301', { cm: '历史单据可左滑复制' }),
          operationList: this.documentsList,
          showKey: 'formName',
          operationMethod: 'selectDocument',
          searchPlaceholder: window.$t('global-1.key162', { cm: '按单据名称查询' }),
        },
      ];
    },
    operationArray() {
      let { hasProxyAuth, hasMultiJobs, skipJobs } = this,
        res = [];
      if (hasProxyAuth) {
        res.push(this.modelArray[0]);
      }
      if (hasMultiJobs && !skipJobs) {
        res.push(this.modelArray[1]);
      }
      if (!this.onlyJob) {
        res.push(this.modelArray[2]);
      }
      if (hasMultiJobs && skipJobs) {
        res.push(this.modelArray[1]);
      }
      return res;
    },
    showRequestTab() {
      return this.COMMON.getOption('corpExpRptControlSetting.displayPurchaseRequisition') !== false;
    },
    createEnters() {
      let { fastCreateDisable, protocol, userProtocol, enableProtocol, isCorpBusiness } = this;
      let corpBusinessTabs = [
        {
          name: window.$t('global-1.key163', { cm: '新建对公支付单' }),
          target: 'expense-report',
          appCode: 'BUSSINESS_PAYMENT',
          disable: false,
          formType: '106',
        },
      ];
      this.showRequestTab &&
        corpBusinessTabs.unshift({
          name: window.$t('global-1.key164', { cm: '新建采购申请单' }),
          target: 'application',
          appCode: 'FOR_SEARCH_SHOP_APPLICATION',
          disable: false,
          formType: '108',
        });
      return isCorpBusiness
        ? corpBusinessTabs
        : [
            {
              name: window.$t('global-1.key165', { cm: '新建申请单' }),
              icon: createAppImg,
              target: 'application',
              appCode: 'APPLICATION_FORM',
              disable: fastCreateDisable.application,
              protocol: protocol.application,
              userProtocol: userProtocol.application,
              enableProtocol: enableProtocol.application,
              formType: '101',
            },
            {
              name: window.$t('global-1.key238', { cm: '新建对公申请单' }),
              icon: createAppImg,
              target: 'application',
              appCode: 'AP_REQUEST',
              disable: fastCreateDisable.apRequest,
              protocol: protocol.apRequest,
              userProtocol: userProtocol.apRequest,
              enableProtocol: enableProtocol.apRequest,
              formType: '113',
            },
            {
              name: window.$t('global-1.key166', { cm: '新建报销单' }),
              icon: createErImg,
              target: 'expense-report',
              appCode: 'EXPENSE_CLAIM',
              disable: fastCreateDisable.expenseReport,
              protocol: protocol.expenseReport,
              userProtocol: userProtocol.expenseReport,
              enableProtocol: enableProtocol.expenseReport,
              formType: '102',
            },
            {
              name: window.$t('global-1.key167', { cm: '新建借款单' }),
              icon: createLoanBillImg,
              target: 'loan-bill',
              appCode: 'LOAN_BILL',
              disable: fastCreateDisable.loanBill,
              protocol: protocol.loanBill,
              userProtocol: userProtocol.loanBill,
              enableProtocol: enableProtocol.loanBill,
              formType: '104',
            },
            {
              name: window.$t('global-1.key168', { cm: '记一笔' }),
              icon: createExpenseImg,
              target: 'expense',
              appCode: 'EXPENSE_LIST',
              disable: fastCreateDisable.expense,
              protocol: protocol.expense,
              userProtocol: userProtocol.expense,
              enableProtocol: enableProtocol.expense,
            },
            {
              name: window.$t('global-1.key216', { cm: '新建合同' }),
              icon: createAppImg,
              target: 'contract',
              appCode: 'CONTRACT',
              disable: fastCreateDisable.contract,
              protocol: protocol.contract,
              userProtocol: userProtocol.contract,
              enableProtocol: enableProtocol.contract,
              formType: '110',
            },
            {
              name: window.$t('global-1.key163', { cm: '新建对公支付单' }),
              icon: createAppImg,
              target: 'expense-report',
              appCode: 'BUSSINESS_PAYMENT',
              disable: fastCreateDisable.businessPayment,
              protocol: protocol.businessPayment,
              userProtocol: userProtocol.businessPayment,
              enableProtocol: enableProtocol.businessPayment,
              formType: '106',
            },
            {
              name: window.$t('global-1.key340', { cm: '新建预提单' }),
              icon: createAppImg,
              target: 'expense-report',
              appCode: 'BUSSINESS_PAYMENT',
              disable: fastCreateDisable.accrual,
              protocol: protocol.accrual,
              userProtocol: userProtocol.accrual,
              enableProtocol: enableProtocol.accrual,
              formType: '114',
            },
          ];
    },
    transformStyle() {
      let { clientWidth, _modeIndex } = this,
        transform = _modeIndex * clientWidth;
      return {
        transform: `translateX(-${transform}px)`,
        webkitTransform: `translateX(-${transform}px)`,
      };
    },
    isSelf() {
      let myInfo = this.$store.getters.getMyInfo;
      return this.currentApplicant && myInfo && this.currentApplicant.userOID === myInfo.userOID && !this.onlyJob;
    },
    needPreSelect() {
      return this.isCorpBusiness && !this.contractLineInfo.contractId && !this.businessParams.apRequestPayInfo;
    },
  },
  watch: {
    keyword() {
      this.searchMethod();
    },
    value(val, old) {
      if (val === this.currentValue) return;

      const isApplication = '101'; // 申请单类型
      if (this.formType === isApplication) {
        this.init();
      } else {
        this.currentValue = val;
      }
    },
    currentValue: {
      handler(val, old) {
        val !== this.value && this.$emit('input', val);
        if (val) {
          this.init();
        } else {
          this.reset();
        }
      },
      immediate: true,
    },
    $route(to, from) {
      this.$plugins.hideLoading();
    },
  },
  methods: {
    ...mapMutations(['setNewApplyParam']),
    ...mapActions(['fetchProxyAuth', 'fetchMyProxyUser', 'fetchUserJobs', 'fetchUserAvailableForms']),
    hasExtrashow(item, showArr) {
      let temp = '';
      showArr.forEach((e, index) => {
        if (index == 0) {
          temp += item[e];
        } else if (item[e]) {
          temp += '-' + item[e];
        }
      });
      return temp;
    },
    multiJobEvent(event) {
      //console.log('event', event);
      if (event.type === 'select') {
        this.closeSearch().then(() => {
          this.selectJob(event.job);
        });
      }
    },
    //设置默认岗位
    doDefaultJob(item, model, e) {
      e.preventDefault();
      let currentDocDefault = item.docDefault;
      let categoryList = model.categoryList;
      categoryList.forEach((category) => {
        let list = category.list;
        list.forEach((item) => {
          item.docDefault = false;
        });
      });
      item.docDefault = !currentDocDefault;
      let cancel = false;
      if (currentDocDefault) {
        cancel = true;
      }

      this.$plugins.showLoading({
        type: 'FIXED',
      });
      defaultUserJobId(item.id, cancel).then(
        (res) => {
          this.$plugins.hideLoading();
          this.currentUserSelectJob = item;
        },
        (error) => {
          this.$plugins.hideLoading();
          item.docDefault = currentDocDefault;
        }
      );
    },
    clearKeyword() {
      this.keyword = '';
    },
    search(forbid) {
      if (forbid) return;
      this.isSearchingMode = true;
      // 打开时初始化搜索结果为当前list
      this.searchResult = this.searchTargetList;
      this.focusInput();
    },
    closeSearch(goBack) {
      let inputName = `input${this.currentMode}`,
        targetInput;
      targetInput = this.$refs[inputName][0];
      targetInput.blur();
      return new Promise((resolve) => {
        // 先收起键盘再收起搜索页
        setTimeout(() => {
          // this.closingSearch = true;  // 保证动画进行完
          this.isSearchingMode = false;
          setTimeout(() => {
            // this.closingSearch = false;
            this.keyword = ''; // 收起之后在清空当前搜索词
            if (goBack) {
              this.goBack();
            }
            resolve();
          }, 300);
        }, 50);
      });
    },
    //上一步
    goBack() {
      let { _modeArray, _modeIndex } = this,
        newIndex = _modeIndex - 1;
      newIndex < 0 && (newIndex = 0);
      switch (this.currentMode) {
        case 'job':
          //this.currentApplicant = {};
          break;
        case 'document':
          if (this.hasMultiJobs) {
            //this.currentJob = {};
          } else {
            //this.currentApplicant = {};
          }
          break;
        default:
          break;
      }
      this.currentMode = _modeArray[newIndex];
    },
    close() {
      this.currentValue = false;
    },
    doSelect(method, item) {
      //[method] selectApplicant 判断是否有岗位
      // 点击之后收起搜索框
      if (this.isSearchingMode) {
        this.closeSearch().then(() => {
          this[method](item);
        });
      } else {
        this[method](item);
      }
    },
    selectApplicant(applicant) {
      this.currentApplicant = applicant;
      this.currentUserSelectJob = null;
      if (applicant.multiJob || applicant.multiJob === undefined) {
        this.initJobs();
      } else {
        this.hasMultiJobs = false;
        this.skipJobs = false;
        if (this.isExpense && !this.quickCreateExpenseClaim) {
          this.currentJob = commonQuickCreatorHandler.joinJobText(this.currentApplicant.jobs)[0].userJobsDTOList[0];
        } else {
          // 单岗时可以不传jobId
          this.currentJob = {};
        }
        this.initDocuments();
      }
    },
    selectDocument(document) {
      this.currentDocument = document;
      let { currentApplicant: applicant, currentJob: job, _formType: formType, copy, copyDetail } = this;
      applicant = applicant || {};
      job = job || {};

      if (copy && formType === '102') {
        this.$plugins.showLoading({
          type: 'FIXED',
        });
        ExpenseReportService.getCopyVerifySetBookId(copyDetail.expenseReportOID, document.formOID)
          .then((res) => {
            if (res.data) {
              this.gotoCreateDocument(formType, document, job, applicant);
            } else {
              this.showToast(window.$t('global-1.key259', { cm: '复制失败，目标表单与原表单不在同一个账套下' }));
              this.close();
            }
          })
          .catch((err) => {
            this.handleError(err);
          })
          .finally(() => {
            this.$plugins.hideLoading();
          });
      } else {
        this.gotoCreateDocument(formType, document, job, applicant);
      }
    },
    gotoCreateDocument(formType, document, job, applicant) {
      this.close();
      setTimeout(() => {
        let res = {
          formType,
          document,
          job,
        };
        applicant.userOID && (res.applicant = applicant);
        this.createDocument(res);
      }, 300);
    },
    selectJob(job) {
      this.currentJob = job;
      this.currentUserSelectJob = job;
      if (this.onlyJob) {
        this.$emit('handleJob', job);
        this.close();
      } else {
        this.initDocuments();
      }
    },
    selectCreateType(type) {
      let { appCode } = type;
      if (this.protocolStatus[appCode] && type.enableProtocol) {
        if (!type.userProtocol || type.userProtocol.status === 'N') {
          this.$handPlugin.confirm.show({
            title: type.protocol.protocolName,
            content: type.protocol.protocolContent,
            leftButtonText: window.$t('global-1.key169', { cm: '不同意' }),
            rightButtonText: window.$t('global-1.key170', { cm: '同意并继续' }),
            titleStyle: { textAlign: 'left' },
            textStyle: { maxHeight: '4.5rem', overflow: 'auto', textAlign: 'left' },
            leftClick: () => {},
            rightClick: () => {
              changeProtocolStatus(appCode, 'Y')
                .then((res) => {
                  this.protocolStatus[appCode] = false;
                  this.differentCreateType(type.target, type);
                })
                .catch((err) => {});
            },
          });
        } else {
          this.differentCreateType(type.target, type);
        }
      } else {
        this.differentCreateType(type.target, type);
      }
    },
    differentCreateType(target, type) {
      if (target === 'expense') {
        this.close();
        setTimeout(() => {
          this.$store.commit('setAppCodeKey', 'EXPENSE_LIST');
          this.hlyRouter.push({
            name: 'expense-create',
            params: {
              mode: 'create',
            },
          });
        }, 300);
      } else if (target === 'ocr-event') {
        this.close();
        setTimeout(() => {
          this.$store.commit('setAppCodeKey', 'EXPENSE_LIST');
          this.hlyRouter.push({
            name: 'expense-list',
            query: {
              directOCR: 'Y',
            },
            params: {
              directOCR: 'Y',
            },
          });
        }, 300);
      } else if (target === 'invoice-scan') {
        this.close();
        setTimeout(() => {
          this.$store.commit('setAppCodeKey', 'EXPENSE_LIST');
          scanService.scanToExpense(this.hlyRouter, this.$handPlugin);
        }, 300);
      } else {
        let { formType } = type;
        this.currentFormType = formType;
        this.$plugins.showLoading({
          type: 'FIXED',
        });
        let proxyAuth = { formType };
        ['106'].includes(formType) && (proxyAuth = { ...proxyAuth, isCopyProxy: false });
        this.fetchProxyAuth(proxyAuth).then(
          (res) => {
            this.hasProxyAuth = res;
            if (res) {
              this.initApplicants();
            } else {
              let { getMyInfo } = this,
                { multiJob } = getMyInfo || {};
              this.currentApplicant = getMyInfo;
              if (multiJob) {
                this.hasMultiJobs = true;
                this.initJobs();
              } else {
                this.hasMultiJobs = false;
                this.initDocuments();
              }
            }
          },
          (e) => {
            this.$plugins.hideLoading();

            this.handleError(e);
          }
        );
      }
    },
    quicklyCreate(item) {
      let {
          appCode,
          formOID,
          formType, // 这里的formType是标示表单具体类型 差旅申请单，费用申请单
          formName,
          applicantOID: userOID,
          applicantName: fullName,
          jobId,
        } = item,
        docFormType, // 这个formType表示单据类型 借款单、申请单或报销单
        applicant = {
          userOID,
          fullName,
        },
        document = {
          formOID,
          formType,
          formName,
          appCode,
        };
      if (appCode.includes('EXPENSE_CLAIM')) {
        docFormType = 102;
      } else if (appCode.includes('LOAN_BILL')) {
        docFormType = 104;
      } else if (appCode.includes('BUSSINESS_PAYMENT')) {
        docFormType = 106;
      } else if (appCode.includes('CONTRACT')) {
        docFormType = 110;
      } else if (appCode.includes('AP_REQUEST')) {
        docFormType = 113;
      } else if (appCode.includes('ACCRUAL')) {
        docFormType = 114;
      } else {
        docFormType = 101;
      }
      this.close();
      setTimeout(() => {
        this.initAppCodeKey(docFormType);
        this.createDocument({
          applicant,
          document,
          job: {
            id: jobId,
          },
          formType: docFormType,
        });
      }, 300);
    },
    initAppCodeKey(formType) {
      const appCodeKeyMap = {
        102: 'EXPENSE_CLAIM',
        104: 'LOAN_BILL',
        106: 'BUSSINESS_PAYMENT',
        110: 'CONTRACTS',
        101: 'APPLICATION_FORM',
        113: 'AP_REQUEST',
        111: 'MY_SUPPLIER',
        114: 'ACCRUAL',
      };
      let appCodeKey = appCodeKeyMap[`${formType}`] || 'APPLICATION_FORM';
      this.$store.commit('setAppCodeKey', appCodeKey);
    },
    createDocument({ formType, applicant, document, job }) {
      const { copy, copyDetail } = this;
      this.$emit('will-create-document', { formType, applicant, document, job });
      formType = Number(formType);
      let { id: jobId } = job;
      this.initAppCodeKey(formType);
      if (formType === 102) {
        if (this.quickCreateExpenseClaim) {
          eventService['er-00000106']({
            isUseRecommend: document.expenseReportOID,
            tenantName: this.getTenantProfile.tenantName,
          });
          this.hlyRouter.push({
            name: 'er-create-new',
            query: {
              formType: document.formType,
              applicantOID: applicant.userOID,
              jobId,
              applicantName: applicant.fullName,
            },
            params: {
              docType: 'expenseReport',
              formOID: document.formOID,
              invoiceOIDs: this.invoiceOIDs,
              createDateList: this.createDateList,
              recommendExpenseOID: document.expenseReportOID,
            },
          });
          return !1;
        }
        // 报销单
        this.hlyRouter.push({
          name: 'er-create-new',
          params: {
            formOID: document.formOID,
            docType: 'expenseReport',
            job: job,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
            operate: copy ? 'copy' : '',
            sourceExpenseReportOID: copy ? copyDetail.expenseReportOID : '', //此处不能为expenseReportOID，否则就是编辑单据了
          },
        });
      } else if (formType === 104) {
        // 借款单
        this.hlyRouter.push({
          name: 'loan-bill-create',
          params: {
            formOID: document.formOID,
            docType: 'loanBill',
            job: job,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
          },
        });
      } else if (formType === 105) {
        // 付款申请单
        this.hlyRouter.push({
          name: 'payment-request-create',
          params: {
            formOID: document.formOID,
            docType: 'paymentRequest',
            job: job,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
          },
        });
      } else if (formType === 106) {
        let extraParams = {};
        let extraQuery = {};
        if (this.quickCreateExpenseClaim) {
          const expenseReportId = document.expenseReportId;
          corEventService['ap-00000140']({
            isHistoryReport: !!expenseReportId,
            lineNum: this.invoiceOIDs.length,
          });
          extraQuery.operate = 'createExpenseAccount';
          if (expenseReportId) {
            extraQuery.operate = 'import';
            extraQuery.relatedCorpExpenseReportId = expenseReportId;
          }
          extraParams.createDateList = this.createDateList;
        }
        this.hlyRouter.push({
          name: 'create-corp-payment',
          params: {
            formOID: document.formOID,
            docType: 'corpPayment',
            job: job,
            contractLineInfo: this.contractLineInfo,
            apRequestPayInfo: this.businessParams.apRequestPayInfo,
            ...extraParams,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
            ...extraQuery,
          },
        });
      } else if (formType === 111) {
        this.hlyRouter.push({
          name: 'my-supplier-basic-info',
          params: {
            formOID: document.formOID,
            id: ':id',
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
          },
        });
      } else if (formType === 110) {
        this.hlyRouter.push({
          name: 'create-contract',
          params: {
            formOID: document.formOID,
            docType: 'contract',
            job: job,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
            jobId,
          },
        });
      } else if (formType === 114) {
        // 预提单
        this.hlyRouter.push({
          name: 'create-accrual',
          params: {
            formOID: document.formOID,
            docType: 'accrual',
            job: job,
          },
          query: {
            formType: document.formType,
            applicantOID: applicant.userOID,
            applicantName: applicant.fullName,
          },
        });
      } else {
        // 申请单
        this.setNewApplyParam('');
        if (document.formType == '4100') {
          // this.hlyRouter.push({
          //     name: "flybackProject"
          // });

          this.hlyRouter.push({
            name: 'handProject',
            query: {
              action: 'create',
              formOID: document.formOID,
              access_token: this.getUserToken.access_token,
              platform: 'isWechat',
            },
          });
        } else {
          if (ApplicationHandler.isAcceptancePOC(document.formType, document.formOID)) {
            this.hlyRouter.push({
              name: 'applicationAcceptanceForm',
              query: {
                mode: 'create',
                formOID: document.formOID,
                formType: document.formType,
              },
            });
            return;
          }
          this.hlyRouter.push({
            name: 'application-create',
            params: {
              formOID: document.formOID,
              docType: 'application',
              job: job,
            },
            query: {
              formType: document.formType,
              applicantOID: applicant.userOID,
              applicantName: applicant.fullName,
              jobId,
            },
          });
        }
      }
    },
    searchMethod: debounce(function () {
      let { keyword, currentMode } = this;
      keyword = keyword.trim();
      if (keyword) {
        keyword = keyword.toLowerCase();

        switch (currentMode) {
          case 'applicant':
            this.searchResult = this.searchApplicant(keyword);
            break;
          case 'job':
            this.searchResult = this.searchJob(keyword);
            break;
          case 'document':
            this.searchResult = this.searchDocument(keyword);
            break;
          case 'default':
            this.searchResult = this.searchTargetList;
            break;
        }
      } else {
        this.searchResult = this.searchTargetList;
      }
    }, 400),
    searchApplicant(keyword) {
      let { searchTargetList } = this;
      return searchTargetList.filter((item) => {
        let { employeeID, fullName } = item;
        return String(employeeID).toLowerCase().includes(keyword) || String(fullName).toLowerCase().includes(keyword);
      });
    },
    searchJob(keyword) {
      const keywordList = keyword.split(' ').filter((item) => !!item);
      let { searchTargetList } = this;
      return searchTargetList
        .map((category) => {
          const list = (category.list || []).filter((item) =>
            keywordList.some((subItem) => {
              const result = pinYinMatch(item.combineText, subItem);
              return result.match;
            })
          );
          return { ...category, list };
        })
        .filter((item) => item.list && item.list.length);
    },
    searchDocument(keyword) {
      let { searchTargetList } = this;
      return searchTargetList.filter((item) => {
        let { formName } = item;
        return String(formName).toLowerCase().includes(keyword);
      });
    },
    focusInput() {
      let _this = this,
        targetInput,
        inputName = `input${this.currentMode}`;

      targetInput = this.$refs[inputName];

      if (targetInput && targetInput.length) {
        targetInput[0].focus();
      } else {
        setTimeout(() => {
          _this.focusInput();
        });
      }
    },
    /**
     * todo 缓存到vuex中
     * 这个迭代没时间做了
     * @returns {Promise<*>}
     */
    async getFastCreate() {
      try {
        let res = await getFastCreate();
        if (res.data) {
          let data = res.data;
          data.forEach((item) => {
            this.protocolStatus[item.appCode] = item.enableProtocol;
            if (item.appCode === 'APPLICATION_FORM') {
              this.fastCreateDisable.application = false;
              this.protocol.application = item.protocol;
              this.userProtocol.application = item.userProtocol;
              this.enableProtocol.application = item.enableProtocol;
            } else if (item.appCode === 'EXPENSE_CLAIM') {
              this.fastCreateDisable.expenseReport = false;
              this.protocol.expenseReport = item.protocol;
              this.userProtocol.expenseReport = item.userProtocol;
              this.enableProtocol.expenseReport = item.enableProtocol;
            } else if (item.appCode === 'EXPENSE_LIST') {
              this.fastCreateDisable.expense = false;
              this.protocol.expense = item.protocol;
              this.userProtocol.expense = item.userProtocol;
              this.enableProtocol.expense = item.enableProtocol;
            } else if (item.appCode === 'LOAN_BILL') {
              this.fastCreateDisable.loanBill = false;
              this.protocol.loanBill = item.protocol;
              this.userProtocol.loanBill = item.userProtocol;
              this.enableProtocol.loanBill = item.enableProtocol;
            } else if (item.appCode === 'BUSSINESS_PAYMENT') {
              this.fastCreateDisable.businessPayment = false;
              this.protocol.businessPayment = item.protocol;
              this.userProtocol.businessPayment = item.userProtocol;
              this.enableProtocol.businessPayment = item.enableProtocol;
            } else if (item.appCode === 'AP_REQUEST') {
              this.fastCreateDisable.apRequest = false;
              this.protocol.apRequest = item.protocol;
              this.userProtocol.apRequest = item.userProtocol;
              this.enableProtocol.apRequest = item.enableProtocol;
            }
          });
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    onVoiceClick(form) {
      this.close();
      if (form.formOID) {
        setTimeout(() => {
          this.$emit('go-voice-record', {
            formOID: form.formOID,
          });
        }, 300);
      }
      return false;
    },

    async fetchHistoryList() {
      try {
        let res = await getCreateHistory();
        if (res && res.data) {
          this.historyList = res.data;
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async fetchHistoryListV2() {
      try {
        let res = await getCreateHistoryV2();
        if (res && res.data) {
          this.historyListV2 = res.data;
        }
        let corpBusinessRes = await corpPaymentServices.getCorpCreateHistory();
        if (corpBusinessRes && corpBusinessRes.data) {
          this.historyListV2 = [...this.historyListV2, ...corpBusinessRes.data];
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },

    joinJobText(data) {
      data = data || [];
      data.forEach((company) => {
        let { userJobsDTOList, companyName } = company;
        company.name = companyName;
        userJobsDTOList.forEach((item) => {
          let { position, rank, duty, tenantDefault } = item,
            tempArr = [];
          if (duty) {
            tempArr.push(window.$t('global-1.key171', { arg1: duty, cm: '职务: {arg1}' }));
          }
          if (rank) {
            tempArr.push(window.$t('global-1.key172', { arg1: rank, cm: '级别: {arg1}' }));
          }
          item.mainText = `${position}`;
          if (tenantDefault) {
            item.mainText = item.mainText + window.$t('global-1.key173', { cm: '（主岗）' });
          }
          item.extraText = item.departmentName || '';
        });
        company.list = userJobsDTOList;
      });
      return data;
    },
    initPreSelect() {
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      Promise.all([this.getFastCreate(), this.fetchHistoryListV2()]).then(
        () => {
          this.$plugins.hideLoading();
        },
        (e) => {
          this.$plugins.hideLoading();
          this.handleError(e);
        }
      );
    },
    initCorpBusiness() {
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      corpPaymentServices.getCorpCreateHistory().then(
        (res) => {
          if (res && res.data) {
            this.historyListV2 = res.data;
          }
          this.$plugins.hideLoading();
        },
        (e) => {
          this.$plugins.hideLoading();
          this.handleError(e);
        }
      );
    },
    initApplicants(copy = false, copyDetail = {}) {
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      let { _formType: formType } = this;
      this.fetchMyProxyUser({ formType }).then(
        (res) => {
          let resArr = [];
          for (let key in res) {
            // user是以oid - obj的形式保存的
            resArr.push(res[key]);
          }
          if (copyDetail) {
            let menu = resArr || [];
            if (formType === '102' && copyDetail.availableForm) {
              let defaultIndex = (resArr || []).findIndex((item) => item.userOID === copyDetail.applicantOID);
              if (defaultIndex > -1) {
                let temp = menu[0];
                menu[0] = menu[defaultIndex];
                menu[defaultIndex] = temp;
              }
            }
            resArr = menu;
          }
          this.applicantsList = resArr || [];
          this.currentMode = 'applicant';
          this.currentValue = true;
          this.$plugins.hideLoading();
        },
        (e) => {
          this.$plugins.hideLoading();

          this.handleError(e);
        }
      );
    },
    getDefaultJob(jobsList, copyDetail) {
      const { businessParams } = this;
      let selectedJob = null;
      const userJobsDTOList = jobsList.reduce((prev, item) => [...prev, ...item.userJobsDTOList], []);
      let defaultJob;
      const defaultJobId = copyDetail?.applicantJobId || businessParams.apRequestPayInfo?.jobId;
      if (defaultJobId) {
        defaultJob = userJobsDTOList.find((job) => job.id === defaultJobId);
      } else {
        defaultJob = userJobsDTOList.find((job) => job.docDefault);
        // 未设置"设为默认岗位"时
        // 读【安全中心-新建单据选择岗位默认选择主岗】的配置
        // 若配置开启，则自动选择主岗为默认岗位
        if (!defaultJob) {
          let companyConfigurations = this.$store.getters.getCompanyConfigurations;
          let docUseDefaultJob = companyConfigurations && companyConfigurations.docUseDefaultJob;
          if (docUseDefaultJob) {
            defaultJob = userJobsDTOList.find((job) => job.tenantDefault);
          }
        }
      }
      if (defaultJob) {
        selectedJob = defaultJob;
      }
      return selectedJob;
    },
    getUniqueJobs(jobsList) {
      let selectedJob = null;
      jobsList.forEach((jobs) => {
        let userJobsDTOList = jobs.userJobsDTOList;
        userJobsDTOList.forEach((job) => {
          selectedJob = job;
        });
      });
      return selectedJob;
    },
    //进入岗位页面
    initJobs(copy, copyDetail) {
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      let { currentApplicant, _formType: formType } = this,
        { userOID } = currentApplicant;
      this.fetchUserJobs({ formType, userOID }).then(
        (res) => {
          this.$plugins.hideLoading();
          if (res.data) {
            this.currentApplicant = res.data;
          }
          if (res && res.multiJob) {
            this.hasMultiJobs = true;
            this.jobsList = commonQuickCreatorHandler.joinJobText(res.jobs);
            this.currentValue = true;
            const defaultJob = this.getDefaultJob(this.jobsList, copyDetail);
            // 有从外面传入的jobId就优先用传入的id
            if ((defaultJob && !this.onlyJob) || (copy && copyDetail.availableJob)) {
              this.skipJobs = true;
              this.selectJob(defaultJob);
            } else {
              this.skipJobs = false;
              this.currentMode = 'job';
            }
            //this.getDefaultJob(this.jobsList)
          } else {
            this.hasMultiJobs = false;
            this.skipJobs = false;
            if (this.isExpense && !this.quickCreateExpenseClaim) {
              this.currentJob = commonQuickCreatorHandler.joinJobText(res.jobs)[0].userJobsDTOList[0];
            } else {
              // 单岗时可以不传jobId
              this.currentJob = {};
            }
            //this.jobsList = joinJobText(res.jobs);
            //let selectedJob = this.getUniqueJobs(this.jobsList);
            //this.currentJob = selectedJob;
            this.initDocuments();
          }
        },
        (e) => {
          this.$plugins.hideLoading();
          this.loadingFlag = false;
          this.handleError(e);
        }
      );
    },
    initDocuments() {
      if (this.isExpense && !this.quickCreateExpenseClaim) {
        // 账本下不是创建报销单的只需要把代理信息传出去
        this.$emit('getProxyInfo', {
          applicant: this.currentApplicant,
          jobInfo: this.currentJob,
        });
        this.close();
        return -1;
      }
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      this.loadingFlag = true;
      let { currentApplicant, _formType: formType, currentJob, copy, copyDetail } = this,
        { id: jobId } = currentJob || {},
        { userOID } = currentApplicant;
      const fetchList = [
        this.fetchUserAvailableForms({
          formType,
          userOID,
          jobId,
          isCopy: copy,
          contractLineInfo: this.contractLineInfo,
          quickCreateExpenseClaim: this.quickCreateExpenseClaim,
          businessParams: this.businessParams,
        }),
      ];
      if (this.quickCreateExpenseClaim) {
        const params = {
          invoiceOIDs: this.invoiceOIDs.split(','),
          jobId: this.currentJob.id || this.currentApplicant.jobs[0].userJobsDTOList[0].id,
          applicationUserOID: this.currentApplicant.userOID,
        };
        const recommendFetch =
          formType === '106'
            ? corpPaymentServices.getCorpRecommendDocumentList
            : ExpenseReportService.getRecommendDocumentList;
        fetchList.push(recommendFetch(params));
      }
      Promise.all(fetchList).then(
        (res) => {
          let menu = [...res[0]] || [];
          if (copy && formType === '102' && copyDetail.availableForm) {
            let defaultIndex = (res[0] || []).findIndex((item) => item.formOID === copyDetail.formOID);
            if (defaultIndex > -1) {
              let temp = menu[0];
              menu[0] = menu[defaultIndex];
              menu[defaultIndex] = temp;
            }
          }
          this.documentsList = menu;
          // 当单据只有一个，并且没有设置默认岗位时，跳过选择单据
          if (!this.skipJobs && res[0] && res[0].length === 1) {
            this.selectDocument(res[0][0]);
            setTimeout(() => {
              this.$emit('input', false);
            }, 200);
            this.currentValue = false;
          } else {
            this.currentMode = 'document';
            this.currentValue = true;
          }
          this.recomDocumentList = (res[1] && res[1].data) || [];
          this.$plugins.hideLoading();
          this.loadingFlag = false;
        },
        (e) => {
          this.$plugins.hideLoading();
          this.loadingFlag = false;
          this.handleError(e);
        }
      );
    },
    initProxy() {
      const { copy, copyDetail = {} } = this;
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      this.loadingFlag = true;
      let { getMyInfo } = this;
      if ((this.onlyJob || this.skipProxy) && !copy) {
        this.currentApplicant = getMyInfo;
        this.hasMultiJobs = false;
        this.initJobs();
      } else if (copy) {
        let { getUserInfo } = this; //getMyInfo会跟筛选的值走，逻辑上不太合理
        if (copy && copyDetail.availableApplicant && getUserInfo.userOID === copyDetail.applicantOID) {
          this.currentApplicant = getUserInfo;
          this.hasMultiJobs = false;
          this.hasProxyAuth = false;
          this.initJobs(copy, copyDetail);
        } else {
          this.hasProxyAuth = true;
          this.initApplicants(false, copyDetail);
        }
      } else {
        this.fetchProxyAuth({ formType: this._formType }).then(
          (res) => {
            this.hasProxyAuth = res;
            if (res) {
              this.initApplicants();
            } else {
              let { getMyInfo } = this;
              this.currentApplicant = getMyInfo;
              this.hasMultiJobs = false;
              this.initJobs();
            }
          },
          (e) => {
            this.loadingFlag = false;
            this.$plugins.hideLoading();
            this.handleError(e);
          }
        );
      }
    },
    init() {
      this.formType && (this.currentFormType = this.formType);
      // !this.formType && !this.onlyJob;
      if (this._hasPreSelect) {
        this.initPreSelect();
        this.currentValue = true;
      } else if (this.needPreSelect) {
        // this.formType === '106' && !this.isExpense;
        this.initCorpBusiness();
        this.currentValue = true;
      } else {
        this.initProxy();
      }
    },
    changeJobs() {
      this.currentMode = 'job';
      this.currentValue = true;
    },
    reset() {
      this.currentUserSelectJob = null;
      this.currentApplicant = {};
      this.currentDocument = {};
      this.currentJob = {};
      this.currentMode = '';
      this.currentFormType = '';
      this.isSearchingMode = false;
      this.keyword = '';
      this.searchResult = [];
      this.historyList = [];
      this.historyListV2 = [];
      this.applicantsList = [];
      this.jobsList = [];
      this.documentsList = [];
      this.recomDocumentList = [];
    },
    format(value = 0, type) {
      if (type === 'date') {
        return moment(value).format('YYYY-MM-DD');
      } else if (type === 'amount') {
        return value
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      }
    },
    isNumber(value) {
      return typeof value === 'number' && !isNaN(value);
    },
  },
  created() {
    this._removeForbidClass();
    this.clientWidth = window.innerWidth || document.body.clientWidth;
  },
  mounted() {
    this.$nextTick(() => {
      this._addForbidClass();
    });
  },
  beforeDestroy() {
    this._reduceForbidClass();
  },

  components: {
    QuicklyCreator,
    EmptyContent,
    PubListItem,
    HlyScroll,
    Loading,
    PopupModal,
    MultiJob,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';

.popup-wrapper {
  &.search-mode {
    transition: height 0.3s ease-in-out;
  }
}

.modal-list-wrapper {
  display: flex;
  width: 400vw;
  height: 100%;
  transition: transform 0.3s ease-in-out;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}

.pre-select {
  background: #fff;

  .create-enter-wrapper {
    height: px(270);
    width: calc(100vw - #{px(60)});
    margin-top: px(20);
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 px(30);

    .create-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .create-item-icon {
        width: px(120);
        margin-bottom: px(20);
      }

      .create-item-name {
        font-family: PingFangSC-Regular;
        font-size: px(28);
        color: #505564;
        text-align: center;
      }
    }
  }

  .latest-doc-title {
    height: px(64);
    width: 100vw;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: px(28);
    color: #8c96b4;
    line-height: px(64);
    background: #f8f8f8;
  }

  .popup-content.latest-doc-wrapper {
    /*px(270) + px(20) + px(64) + px(88)*/
    height: calc(100% - #{px(522)});
  }
}

.modal-wrapper {
  height: 100%;
  overflow: hidden;
  width: 100vw;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  .select-model {
    background: #fff;
    height: 100%;
    overflow: hidden;
    width: 100%;
  }

  .search-model {
    height: 100%;
    overflow: hidden;
    background: #ebecef;
    width: 100%;
  }

  &.border-right {
    position: relative;

    &:before {
      content: '';
      width: 2px;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #d7dce6;
      transform-origin: 0 0;
      transform: scaleX(0.5);
    }
  }

  .popup-header-search {
    padding-bottom: px(10);

    .base-search-head {
      height: px(100);
      background: #fff;
      display: flex;
      align-items: center;
      &.ignore-rem {
        padding: 0 10px;
      }

      &.border-bottom {
        border-bottom: 2px solid #d7dce6;
      }

      .base-search-body {
        flex-grow: 1;
        height: px(60);
        font-size: px(24);
        color: #8c96b4;
        background: #ebedef;
        border-radius: px(80);
        display: flex;
        align-items: center;
        width: min-content;
        // 750px/20px => rem/10px，现在不需要转rem直接缩小一倍
        &.ignore-rem {
          padding: 0 10px;
        }
      }

      .search-icon {
        width: px(28);
        height: px(28);
        margin-right: px(10);
      }

      .search-input-area {
        background: inherit;
        font: inherit;
        border: none;
        outline: none;
        width: calc(100% - #{px(28)});
      }

      .clear-search-icon {
        width: px(24);
        height: px(24);
        padding: px(4);
        padding-left: px(10);
      }
    }

    .cancel-search-button {
      color: $mainColor;
      font-size: px(32);
      &.ignore-rem {
        padding: 5px 0 5px 10px;
      }
    }
  }

  .input-style {
    flex: 8;
    color: #1e3255;

    .search-input {
      width: 96%;
      border: 2px solid #ddd;
      height: 60px;
      margin: 6px 2%;
      padding-left: 10px;
      background: #fff;
      position: relative;
      outline: none;
    }

    .clear {
      position: absolute;
      top: 30px;
      width: 30px;
      right: 15%;
    }
  }

  .left-arrow {
    width: px(100);

    .go-back {
      flex: 1;
      display: flex;
      align-items: center;

      .go-back-img {
        width: px(40);
      }
    }
  }

  .title {
    flex: 1;
    color: #505564;
    font-size: px(32);
    text-align: center;

    .sub-title {
      font-size: px(24);
      color: $mainColor;
    }
  }

  .right-arrow {
    width: px(100);
    position: relative;
    color: #9d9d9d;
    text-align: right;

    .right-arrow-img {
      width: px(36);
      height: px(36);
    }
  }

  .popup-header {
    padding: 0 44px;
    height: px(110);
    display: flex;
    align-content: center;
    align-items: center;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background: #d7dce6;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
    }
  }

  .popup-content,
  .popup-content-search {
    position: relative;
    height: calc(100% - #{px(278)});
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    //-webkit-backface-visibility: hidden;
    //transform: translate3d(0, 0, 0);
    text-align: center;
    width: 100%;
    padding: 0;
    color: #505564;

    .default-jobs {
      padding: px(30) px(40);
      background: #f8f8f8;
      text-align: left;

      .jobs {
        font-family: PingFangSC-Regular;
        font-size: px(28);
        color: #505564;
        letter-spacing: 0;
        line-height: px(28);
        display: flex;
        width: 85%;

        .position {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .default-text {
          padding: px(2) px(10);
          background: #e9e9e9;
          border-radius: 4px;
          font-family: PingFangSC-Regular;
          font-size: px(22);
          color: #8c96b4;
          letter-spacing: 0;
          line-height: 1;
          margin-left: px(10);
          white-space: nowrap;
        }
      }

      .company {
        margin-top: px(16);
        margin-right: px(75);
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #8c96b4;
        line-height: px(24);
      }

      .change-job {
        position: absolute;
        right: px(40);
        top: px(40);
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #505564;
        line-height: px(28);
      }
    }

    .list-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      position: relative;
      font-size: px(30);
      padding: px(30) px(40);

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: px(30);
        bottom: 0;
        width: calc(100% - #{px(60)});
        height: 2px;
        background: #d7dce6;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
      }

      &.has-voice-input .list-row {
        /* 100 * 2 + 4 避免与录音按钮重叠*/
        width: calc(100% - #{px(204)});
      }

      .list-row {
        width: 100%;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: PingFangSC-Medium;
        font-size: px(32);
        color: #0a0f1e;
      }

      .list-item-inner {
        text-align: left;
        width: 100%;

        .list-item-inner2 {
          text-align: left;
          width: 100%;

          &.show-default {
            width: 80%;
          }
        }
      }

      .default-job {
        position: absolute;
        top: 0;
        right: px(40);
        bottom: 0;

        .default-job-inner {
          display: flex;
          height: 100%;
          align-items: center;

          .check-img {
            font-size: px(28);
            color: $mainColor;
          }

          .text {
            font-family: PingFangSC-Regular;
            font-size: px(26);
            color: #505564;
            line-height: px(28);
            margin-left: px(12);
          }
        }
      }

      .extra-text {
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #8c96b4;
      }
    }

    .voice-wrapper {
      width: px(50);
      height: px(50);
      position: absolute;
      right: px(0);
      background: #fff;
      border-left: 2px solid #d7dce6;
      padding: 0 px(25);
    }

    .category-name {
      background: $boxGroundingColor;
      height: px(64);
      font-family: PingFangSC-Regular;
      font-size: px(30);
      line-height: px(64);
      color: #8c96b4;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 px(40);
    }
  }

  .popup-content.has-expense-item {
    text-align: left;
    .document-title {
      background-color: #f3f6f9;
      color: #71757e;
      padding: px(8) px(32);
      line-height: px(40);
      font-size: px(26);
    }
    .recommend-document {
      .recommend-item {
        padding: px(32);
        &.not-last {
          border-bottom: solid px(2) #f2f2f3;
        }
        .formName,
        .createDate {
          display: inline-block;
          font-size: px(32);
          line-height: px(48);
          color: #252629;
          font-weight: bold;
        }
        .title,
        .amount {
          display: inline-block;
          font-size: px(20);
          line-height: px(32);
          color: #71757e;
        }
        .createDate,
        .amount {
          float: right;
        }
        .formName {
          max-width: 70%;
        }
        .mark-and-amount {
          display: flex;
          .title {
            flex: 1;
            text-align: left;
          }
          .amount-wrap {
            display: flex;
            flex-direction: column;
            align-items: end;
          }
        }
      }
    }
  }

  .popup-content-search {
    max-height: calc(100% - #{px(110)});
    height: auto;
    background: #fff;

    .list-item:last-of-type::after {
      display: none;
    }
  }

  .bscroll {
    height: calc(100% - #{px(110)});
    padding: 0 px(20);
  }

  .relate-item-wrapper {
    margin-bottom: px(10);
  }

  .popup-footer {
    position: relative;
    bottom: 0;
    height: px(180);
    display: flex;
    align-items: center;
    touch-action: none;

    /*&::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 2px;
        background: #D7DCE6;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
      }*/

    .close-img {
      margin-left: auto;
      margin-right: auto;
      width: px(100);
      height: px(100);
    }
  }
}
</style>
